import { useSelector } from 'react-redux'

import {
  selectAllocationKeysData,
  selectAllocationKeysFetched
} from 'redux/selectors/AllocationKeys'

export const useAllocationKeysData = () => {
  return useSelector(selectAllocationKeysData)
}

export const useAllocationKeysFetched = () => {
  return useSelector(selectAllocationKeysFetched)
}
